import { Component, Vue } from 'types-vue'

@Component
export default class TopbarTable extends Vue {}